import "./changeMail.scss";
import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { changeEmail } from "../../../../store/reducers/reducerUser";
import { useNavigate } from "react-router-dom";
import { useLang } from "../../../../i18n/LangContext";

const ChangeEmail = () => {
  const [currentEmail, setCurrentEmail] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [confirmNewEmail, setConfirmNewEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const { t } = useLang();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const scrollTargetRef = useRef(null);
  useEffect(() => {
    const yOffset = -120;
    const y =
      scrollTargetRef.current.getBoundingClientRect().top +
      window.pageYOffset +
      yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(currentEmail)) {
      setMessage("Please enter a valid current email.");
      return;
    }

    if (!emailRegex.test(newEmail)) {
      setMessage("Please enter a valid new email.");
      return;
    }

    if (newEmail !== confirmNewEmail) {
      setMessage("New email and confirmation do not match.");
      return;
    }

    if (!password || password.length < 4) {
      setMessage("Please enter your password (at least 4 characters).");
      return;
    }

    if (currentEmail === newEmail) {
      setMessage("New email must be different from the current email.");
      return;
    }

    setLoading(true);
    const actionResult = await dispatch(
      changeEmail({ currentEmail, newEmail, password })
    );

    if (changeEmail.fulfilled.match(actionResult)) {
      setMessage("Email updated successfully.");
      setPassword("");
      setConfirmNewEmail("");

      setTimeout(() => {
        setLoading(false);
        navigate(-1);
      }, 1000);
      return;
    }

    if (changeEmail.rejected.match(actionResult)) {
      const errText =
        (typeof actionResult.payload === "string" && actionResult.payload) ||
        "Failed to update email.";
      setMessage(errText);
    }

    setLoading(false);
  };

  return (
    <div className="changeEmailContainer">
      <h2 ref={scrollTargetRef}>{t("change_email")}</h2>
      <form onSubmit={handleSubmit} className="changeEmailForm">
        <input
          type="email"
          placeholder={t("current_email")}
          required
          value={currentEmail}
          onChange={(e) => setCurrentEmail(e.target.value)}
        />

        <input
          type="email"
          placeholder={t("new_email")}
          required
          value={newEmail}
          onChange={(e) => setNewEmail(e.target.value)}
        />

        <input
          type="email"
          placeholder={t("confirm_new_email")}
          required
          value={confirmNewEmail}
          onChange={(e) => setConfirmNewEmail(e.target.value)}
        />

        <input
          type="password"
          placeholder={t("password_verify")}
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <div className="changeEmailActions">
          <button type="submit" disabled={loading}>
            {loading ? t("updating") : t("update")}
          </button>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="cancelBtn"
          >
            {t("cancel")}
          </button>
        </div>
      </form>
      {message && <div className="changeEmailMessage">{message}</div>}
    </div>
  );
};

export default ChangeEmail;
